import fetch from '@/utils/fetch'

// 获取云盘/群盘资源的所有标签
export function resourceTagAllList (params = {}) {
  return fetch({
    url: '/resource/tag/all/list',
    method: 'get',
    params: {
      group_number: params.group_number,
      disk_type: params.disk_type
    }
  })
}

// 获取文件(夹)标签
export function resourceTagList (params = {}) {
  return fetch({
    url: '/resource/tag/list',
    method: 'get',
    params: {
      resource_number: params.resource_number,
      group_number: params.group_number,
    }
  })
}

// 设置文件(夹)标签
export function handleResourceTag (data) {
  return fetch({
    url: '/resource/tag',
    method: 'post',
    data
  })
}